import { ValueOf } from '@redsift/design-system';

export type ChartDimensions = {
  width: number;
  height: number;
};

export const ChartSize = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;
export type ChartSize = ValueOf<typeof ChartSize>;

export type MarginProps = {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
};
